<div class="step-container">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="mb-5" *ngIf="!loading">
      <div class="d-flex d-lg-none justify-content-center">
        <img alt="" src="assets/images/login-registration/registration-logo.svg" class="logo mb-3" />
      </div>
      <h5 class="text-primary text-center text-lg-left">Add Personal Details</h5>

      <fgbcl-errors></fgbcl-errors>
      <form [formGroup]="personalDetailsForm">
        <div class="form-row">
          <div class="form-group col-lg-6">
            <label class="mb-2" for="Title">Title</label>
            <select
              id="Title"
              class="form-control border-0 bg-muted"
              formControlName="Title"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.Title.errors }"
              required
            >
              <option value="Mr">Mr.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Ms">Ms.</option>
              <option value="O">Other</option>
            </select>
            <div class="invalid-feedback">Please select a title.</div>
          </div>
          <div class="form-group col-lg-6">
            <label class="mb-2" for="FirstName">First Name</label>
            <input
              id="FirstName"
              class="form-control border-0 bg-muted"
              type="text"
              formControlName="FirstName"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.FirstName.errors }"
              required
            />
            <div class="invalid-feedback">Please enter your first name.</div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-lg-6">
            <label class="mb-2" for="Surname">Last Name</label>
            <input
              id="Surname"
              class="form-control border-0 bg-muted"
              type="text"
              formControlName="Surname"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.Surname.errors }"
              required
            />
            <div class="invalid-feedback">Please enter your last name.</div>
          </div>
          <div class="form-group col-lg-6">
            <label class="mb-2" for="DOB" (click)="dobDatePicker.toggle()">Date of Birth</label>
            <div class="input-group">
              <input
                class="form-control border-0 bg-muted"
                name="DOB"
                type="text"
                formControlName="DOB"
                [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.DOB.errors }"
                ngbDatepicker
                #dobDatePicker="ngbDatepicker"
                [minDate]="{ year: today.getFullYear() - 100, month: today.getMonth() + 1, day: today.getDate() }"
                [maxDate]="{ year: today.getFullYear() - 18, month: today.getMonth() + 1, day: today.getDate() }"
                (click)="dobDatePicker.toggle()"
                autocomplete="off"
                required
              />
              <div class="input-group-append">
                <button
                  class="btn icon icon-calendar bg-muted font-weight-bold py-0"
                  type="button"
                  (click)="dobDatePicker.toggle()"
                  attr.aria-label="{{ 'registration.toggle.dob.screenreader' | translate }}"
                ></button>
              </div>
            </div>
            <div class="invalid-feedback">Please enter a valid date of birth.</div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-lg-6">
            <label class="mb-2" for="Address1">Street</label>
            <input
              id="Street"
              class="form-control border-0 bg-muted"
              name="Street"
              type="text"
              formControlName="Street"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.Street.errors }"
              required
            />
            <div class="invalid-feedback">Please enter a value.</div>
          </div>
          <div class="form-group col-lg-6">
            <label class="mb-2" for="Town">City</label>
            <input
              id="Town"
              class="form-control border-0 bg-muted"
              name="Town"
              type="text"
              formControlName="Town"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.Town.errors }"
              required
            />
            <div class="invalid-feedback">Please enter a value.</div>
          </div>
        </div>

        <fgbcl-country-and-regions [Form]="personalDetailsForm" [HasSubmitted]="hasSubmitted"></fgbcl-country-and-regions>

        <div class="form-row">
          <div class="form-group col-lg-6">
            <label class="mb-2" for="PostCode">Post Code</label>
            <input
              id="PostCode"
              class="form-control border-0 bg-muted"
              name="PostCode"
              type="text"
              formControlName="PostCode"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.PostCode.errors }"
              required
            />
            <div class="invalid-feedback">Please enter a valid postal code.</div>
          </div>

          <div class="form-group col-lg-6">
            <label class="mb-2" for="HomeNumber">Mobile Number</label>
            <input
              id="HomeNumber"
              class="form-control border-0 bg-muted"
              name="HomeNumber"
              type="tel"
              formControlName="HomeNumber"
              [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.HomeNumber.errors }"
              required
            />
            <div class="invalid-feedback">Please enter a valid phone number.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="mb-2" for="EmailAddress1">Email Address</label>
          <input
            id="EmailAddress1"
            class="form-control border-0 bg-muted"
            type="email"
            formControlName="EmailAddress1"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!personalDetailsForm.controls.EmailAddress1.errors }"
            required
          />
          <div class="invalid-feedback">Please enter a valid email address.</div>
        </div>
        <!--This is for clubs that need shipping adresses implemented (Not part of Template Design)-->
        <!-- <div class="custom-control custom-checkbox mb-4 pl-4">
          <input
            id="ShouldAddShipping"
            class="form-control border-0 custom-control-input"
            name="ShouldUseShippingAddress"
            type="checkbox"
            formControlName="ShouldUseShippingAddress"
          />
          <label class="custom-control-label pr-5 pt-1" for="ShouldAddShipping">
            Check here to add a shipping address on the next page.
          </label>
        </div> -->
      </form>
    </div>
    <ng-container *ngIf="loading">
      <div class="w-100">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </ng-container>
    <div class="button-container position-absolute">
      <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
    </div>
  </div>
</div>
